import React, { useEffect, useState } from "react";
import { collection, query, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { doc, deleteDoc } from "firebase/firestore";
import { Link } from "react-router-dom";

const StudentsField = () => {
  const [list, setList] = useState([]);
  const [studentDetails, setStudentDetails] = useState("");
  const [studied, setStudied] = useState("");
  const [classSection, setClassSection] = useState("");
  const [viewAll, setViewAll] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  useEffect(() => {
    const q = query(collection(db, "admissionStudentList"));
    onSnapshot(q, (querySnapshot) => {
      let studentArray = [];
      querySnapshot.forEach((doc) => {
        studentArray.push({ id: doc.id, ...doc.data() });
      });
      setList(studentArray);
    });
  }, []);

  let tempArr = [];
  tempArr = list?.filter(
    (item) => item?.studied === studied && item?.classSection === classSection
  );

  const deleteField = async (sid) => {
    await deleteDoc(doc(db, "admissionStudentList", sid)).then(() => {
      // alert("Application form submitted successfully")
      window.location.reload(false);
    });
    console.log("Deleted ===>" + sid);
  };

  useEffect(() => {
    const res = list?.find((item) => item?.id === deleteId);
    setStudentDetails(res);
  }, [deleteId]);

  return (
    <div className="p-5  min-h-screen">
      <div className="grid grid-cols-3  pl-5 pr-5 ">
        <div className="w-full max-w-sm">
          <div className="md:flex md:items-center mb-6">
            <div className="md:w-1/4">
              <label
                className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                htmlFor="inline-full-name"
              >
                Class
              </label>
            </div>
            <div className="md:w-1/2">
              <select
                value={studied}
                onChange={(e) => {
                  setStudied(e.target.value);
                }}
                className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              >
                <option value="null"> select</option>
                <option value="1">Class I</option>
                <option value="2">Class II</option>
                <option value="3">Class III</option>
                <option value="4">Class IV</option>
                <option value="5">Class V</option>
                <option value="6">Class VI</option>
                <option value="7">Class VII</option>
                <option value="8">Class VIII</option>
                <option value="9">Class IX</option>
                <option value="10">Class X</option>
                <option value="11">Class XI</option>
                <option value="12">Class XII</option>
              </select>
            </div>
          </div>
        </div>
        <div className="w-full max-w-sm">
          <div className="md:flex md:items-center mb-6">
            <div className="md:w-1/4">
              <label
                className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                htmlFor="inline-full-name"
              >
                Section
              </label>
            </div>
            <div className="md:w-1/2">
              <select
                value={classSection}
                onChange={(e) => {
                  setClassSection(e.target.value);
                }}
                className="form-select  block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                aria-label="Default select example"
              >
                <option value="null"> select</option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="C">C</option>
                <option value="D">D</option>
                <option value="E">E</option>
                <option value="F">F</option>
              </select>
            </div>
          </div>
        </div>
        <div className="w-full mb-6">
          <div className="md:w-full text-center">
            <button
              className="text-white bg-yellow-600 py-1 px-1 rounded-md w-32 ml-20 "
              onClick={() => setViewAll(!viewAll)}
            >
              View All
            </button>
          </div>
        </div>
      </div>
      <h1 className="text-left mb-4 ml-2 text-3xl font-semibold">
        Student List
      </h1>
      <table className="w-full  text-center">
        <thead className="border-b  ">
          <tr className="bg-gray-100">
            <th className="py-3 "> Sl No.</th>
            <th className="py-3 "> Class</th>
            <th className="py-3 "> Roll No.</th>
            <th className="py-3 "> Name</th>
            <th className="py-3 ">Student Code</th>
            <th className="py-3 "> Category</th>
            <th className="py-3 ">Gender</th>
            <th className="py-3 ">View</th>
            <th className="py-3 ">Update</th>
            <th className="py-3 ">Delete</th>
          </tr>
        </thead>
        <tbody>
          {[...tempArr]
            .sort((a, b) => a.studentRollNumber - b.studentRollNumber)
            .map((item, index) => (
              <tr className="border-b" key={index}>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {++index}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.studied}
                  {item.classSection}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.studentRollNumber}
                </td>
                <td className="py-3 px-3 text-sm font-medium text-gray-900 border-r">
                  {item.fullName}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.studentIdNumber}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.category}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.gender}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  <Link
                    to={"../studentDetailsAll"}
                    state={{ studentId: item.id }}
                  >
                    <button className="text-white bg-yellow-600 py-1 px-1 rounded-md">
                      View
                    </button>
                  </Link>
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  <Link to={"../updateStudents"} state={{ studentId: item.id }}>
                    <button className="text-white bg-green-600 py-1 px-1 rounded-md">
                      Update
                    </button>
                  </Link>
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  <button
                    className="text-white bg-red-600 py-1 px-1 rounded-md "
                    onClick={() => setShowModal(true)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
        </tbody>

        {viewAll && (
          <tbody>
            {list
              .sort((a, b) => b.studentIdNumber - a.studentIdNumber)
              .map((item, index) => (
                <tr className="border-b" key={index}>
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    {++index}
                  </td>
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    {item.studied}/{item.classSection}
                  </td>
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    {item.studentRollNumber}
                  </td>
                  <td className="py-3 px-3 text-sm font-medium text-gray-900 border-r">
                    {item.fullName}
                  </td>
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    {item.studentIdNumber}
                  </td>
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    {item.category}
                  </td>
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    {item.gender}
                  </td>
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    <Link
                      to={"../studentDetailsAll"}
                      state={{ studentId: item.id }}
                    >
                      <button className="text-white bg-yellow-600 py-1 px-1 rounded-md">
                        View
                      </button>
                    </Link>
                  </td>
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    <Link
                      to={"../updateStudents"}
                      state={{ studentId: item.id }}
                    >
                      <button className="text-white bg-green-600 py-1 px-1 rounded-md">
                        Update
                      </button>
                    </Link>
                  </td>
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    <button
                      className="text-white bg-red-600 py-1 px-1 rounded-md "
                      onClick={() => {
                        setShowModal(true);
                        setDeleteId(item.id);
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        )}
      </table>

      {showModal && (
        <div className="justify-center items-center fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity flex overflow-x-hidden overflow-y-auto  z-50 outline-none focus:outline-none">
          <div className="relative w-auto my-6 mx-auto max-w-3xl">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-3xl font-semibold">Delete Data</h3>
              </div>

              <div className="relative p-6 flex-auto">
                <div className="my-4 text-slate-500 text-lg leading-relaxed">
                  Are you sure you want to delete
                  <div className="flex flex-col">
                    <span>Name : {studentDetails?.fullName}</span>
                    <span>Reg. No. : {studentDetails?.studentIdNumber}</span>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => setShowModal(false)}
                >
                  cancle
                </button>
                <button
                  className="bg-red-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => deleteField(deleteId)}
                >
                  delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentsField;
